module.exports = __webpack_public_path__ + "static/media/carousel-arrow-right.0ccb3650.svg";